import React from "react";
import moment from "moment";
import "./CreditTable.css";
import { CreditTypeBadge, StatusBadge } from "../Badges/Badges";
import { isRefundableType } from "../../../enums/CreditResourceType";

const fmt = (date) => (date ? moment(date).format("DD/MM/YYYY HH:mm") : "-");

// Modern, horizontally-scrollable credit table.
// Used both for the main credit list and inside the expandable user-email rows.
function CreditTable({
  data = [],
  loading = false,
  onUpdateStatus,
  onRefund,
  emptyText = "Kayıt bulunamadı.",
}) {
  const rows = [...data].sort((a, b) => b.Id - a.Id);

  return (
    <div className="credit-table-wrapper">
      <table className="credit-table">
        <thead className="credit-table-head">
          <tr>
            <th>ID</th>
            <th>CreditResourceType</th>
            <th>Başlangıç</th>
            <th>Bitiş</th>
            <th>Status</th>
            <th>Promosyon</th>
            <th>Promosyon Kodu</th>
            <th>Product ID</th>
            <th>GPA</th>
            <th>Kullanıcı ID</th>
            <th className="credit-table-actions-col">İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td className="credit-table-empty" colSpan={11}>
                {emptyText}
              </td>
            </tr>
          ) : (
            rows.map((credit) => (
              <tr className="credit-table-row" key={credit.Id.toString()}>
                <td className="credit-cell-id">{credit.Id}</td>
                <td>
                  <CreditTypeBadge type={credit.CreditResourceType} />
                </td>
                <td className="credit-cell-date">{fmt(credit.StartDate)}</td>
                <td className="credit-cell-date">{fmt(credit.EndDate)}</td>
                <td>
                  <StatusBadge status={credit.Status} />
                </td>
                <td>{credit.PromotionName || "-"}</td>
                <td>{credit.PromotionCode || "-"}</td>
                <td>{credit.ProductId || "-"}</td>
                <td>{credit.OrderId ? credit.OrderId : "-"}</td>
                <td>{credit.UserId}</td>
                <td className="credit-table-actions-col">
                  <div className="credit-row-actions">
                    <button
                      type="button"
                      className="credit-btn credit-btn-secondary"
                      onClick={() => onUpdateStatus && onUpdateStatus(credit)}
                    >
                      {loading ? "Yükleniyor" : "Update Status"}
                    </button>
                    {Number(credit.Status) === 1 &&
                      isRefundableType(credit.CreditResourceType) && (
                        <button
                          type="button"
                          className="credit-btn credit-btn-danger"
                          onClick={() => onRefund && onRefund(credit)}
                        >
                          İade Et
                        </button>
                      )}
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default CreditTable;
